import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';

const styles = theme => ({
    count:{
        position:'absolute',
        top:'50%',
        marginTop:'-12px',
        right:'0'
    },
    countMain: {
        backgroundColor:'#ff0000',
        color:'#ffffff',
        border:'1px solid #ff0000',
        padding:'3px 6px',
    },
    countSecondary: {
        backgroundColor:'#ffffff',
        color:'#000000',
        border:'1px solid #ff0000',
        padding:'3px 6px',
    }
});

class DoubleBubble extends Component {
    render() {
        const {classes} = this.props;
        const bg = this.props.bg || '#FF0000';
        const fg = this.props.fg || '#FFFFFF';
        return (
            <div className={classes.count}>
                <span className={classes.countMain} style={{borderColor:bg, backgroundColor:bg, color:fg}}>{this.props.main}</span>
                {this.props.alt !== false &&
                    <span className={classes.countSecondary} style={{borderColor: bg}}>{this.props.alt}</span>
                }
            </div>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(DoubleBubble)));
